module.exports = __webpack_public_path__ + "b49a90ee8c246157637b5ed142005d12.woff";


//////////////////
// WEBPACK FOOTER
// ./~/@blueprintjs/core/resources/icons/icons-16.woff
// module id = 2464
// module chunks = 0